const mainNavigationItems = document.querySelectorAll(".header__navigation > ul > li > a");

const closeMenu = () => {
    [].forEach.call(mainNavigationItems, el => {
        const parentClassList = el.parentNode.classList;
        if (parentClassList.contains("is-active")) {
            parentClassList.remove("is-active")
        }
    })
}

export {closeMenu}